'use strict';
var React = require('react');
var ReactDOM = require('react-dom');
var projectLoadHelper = require('../../helper/projectLoadHelper');
var appTypes = require('../../types/appTypes.js');
var util = require('../../helper/util');
var styleHelper = require('../../helper/styleHelper');

/**
 @Author : mengxiaojiang
 @CreateDate :
 @Descriptor : 图片轮播组件中的各个图片层
 */
var ImageBackground = React.createClass({

  render: function () {
    var c = this.props.color;
    //if(util.Color.toRGBA(c).a === 0){
    //  c = '#fff'
    //}
    return (<div key={this.props.controlID} className="imgBackground" style={{backgroundColor : c}}>
      <img
        ref="img"
        id={this.props.controlID + '-image'}
        src={projectLoadHelper.loadImage(this.props.URL)}
        onLoad={this.onAdjustImgBoundsWithLoad}
      />
      <canvas ref="noImg" style={{width:'100%',height:'100%',position:'absolute'}}/>
    </div>);
  },

  componentDidMount : function(){
    this.doDrawEmptyImg();
  },

  componentDidUpdate : function(){
    this.onAdjustImgBoundsWithLoad();
  },

  doDrawEmptyImg : function(){
    var ctx = ReactDOM.findDOMNode(this.refs.noImg);
    var g = ctx.getContext('2d');
    ctx.width = ctx.clientWidth;
    ctx.height = ctx.clientHeight;
    g.lineWidth = 1;
    g.strokeStyle = '#000';
    g.fillStyle = '#fff';
    g.strokeWidth = 1;
    g.rect(0.5,0.5,ctx.width - 1,ctx.height - 1);
    g.fill();
    g.moveTo(5,5);
    g.lineTo(ctx.width - 5,ctx.height - 5);
    g.moveTo(5,ctx.height - 5);
    g.lineTo(ctx.width - 5,5);
    g.stroke();

  },

  imgSize : undefined,
  /**
   * 图片加载完成后，根据布局模式调整图片的区域
   */
  onAdjustImgBoundsWithLoad: function () {
    var fitMode = this.props.fitMode;
    var img = ReactDOM.findDOMNode(this.refs.img);
    var imgW;
    var imgH;
    var w = styleHelper.getWidth(this.props);
    var h = styleHelper.getHeight(this.props);
    var sx = 1;
    var sy = 1;
    var sw;
    var sh;
    var left;
    var top;
    if (img) {
      $(ReactDOM.findDOMNode(this.refs.noImg)).css({visibility:'hidden'});
      if(this.imgSize && this.imgSize.width !== 0 && this.imgSize.height !== 0){
        imgW = this.imgSize.width;
        imgH = this.imgSize.height;
      }else {
        imgW = img.clientWidth;
        imgH = img.clientHeight;
        this.imgSize = {
          width : imgW,
          height : imgH
        };
      }

      if (imgW !== 0) {
        sx = w / imgW;
      }
      if (imgH !== 0) {
        sy = h / imgH
      }

      if(!imgW){
        imgW = w;
      }
      if(!imgH){
        imgH = h;
      }
      if (fitMode === appTypes.ImageCarouselFitMode.AUTO) {
        sx = Math.max(sx, sy);
        sy = Math.max(sx, sy);
      }
      sw = imgW * sx;
      sh = imgH * sy;
      left = (w - sw) / 2;
      top = (h - sh) / 2;
      $(img).css({
        width: sw,
        height: sh,
        left: left,
        top: top
      });
    }
  }
});

module.exports = ImageBackground;



// WEBPACK FOOTER //
// ./src/views/Components/ImageBackground.jsx